import * as React from "react"
import {useState} from "react"
import {apiRequestScheduleMeeting} from "../../api/apiRequests"
import Loader from "../ui/Loader"

interface BookingModalProps {
  specialistName: string,
  onClose: () => void,
}

const BookingModal = ({specialistName, onClose}: BookingModalProps) => {
  const [meetingDate, setMeetingDate] = useState("")
  const [meetingTime, setMeetingTime] = useState("")
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle")
  const today = new Date().toISOString().split("T")[0]

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!meetingDate || !meetingTime) return
    setStatus("loading")
    const result = await apiRequestScheduleMeeting({specialistName, meetingDate, meetingTime})
    if (result && result.result === "success") {
      setStatus("success")
    } else {
      setStatus("error")
    }
  }

  return (
    <div className="meeting-modal__overlay" onClick={onClose}>
      <div className="meeting-modal__box" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="meeting-modal__x" onClick={onClose} aria-label="Close">✕</button>
        {status === "success" ? (
          <div className="meeting-modal__success">
            <h3>Your meeting has been scheduled!</h3>
            <p>We have sent a confirmation to your email. Our specialist will contact you shortly.</p>
            <button className="meeting-modal__close-btn" onClick={onClose}>Close</button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <h3 className="meeting-modal__title">Schedule your appointment</h3>
            <p className="meeting-modal__subtitle">Choose a date and time convenient for you for an online meeting with a manager.</p>
            <div className="meeting-modal__field">
              <label className="meeting-modal__label">Select date</label>
              <input
                type="date"
                min={today}
                value={meetingDate}
                onChange={(e) => setMeetingDate(e.target.value)}
                required
              />
            </div>
            <div className="meeting-modal__field">
              <label className="meeting-modal__label">Select time</label>
              <input
                type="time"
                value={meetingTime}
                onChange={(e) => setMeetingTime(e.target.value)}
                required
              />
            </div>
            {status === "error" && (
              <p className="meeting-modal__error">Something went wrong. Please try again.</p>
            )}
            <button
              type="submit"
              className="meeting-modal__submit"
              disabled={!meetingDate || !meetingTime || status === "loading"}
            >
              {status === "loading" ? <Loader size="button"/> : <>Schedule your appointment <span>↗</span></>}
            </button>
          </form>
        )}
      </div>
    </div>
  )
}

export default BookingModal
